/**
 * Standalone routes for portal-app
 * This is a copy of @portal/common/dist/routes to avoid build-time dependencies
 */

'use strict';

const Route = {
  MciReports: '/mci-reports',
  OfferManagement_PersonalLoans_MciConversionsReports:
    '/offer-management/personal-loans/mci-reports/conversions',
  OfferManagement_PersonalLoans_MciOffersReports:
    '/offer-management/personal-loans/mci-reports/offers',
  OfferManagement_PersonalLoans_MciRejectionsReports:
    '/offer-management/personal-loans/mci-reports/rejections',
};

const DemandMVPOfferManagementRoute = {
  AutoLoanRefi: '/offer-management/financial-services/auto-loan-refi',
  CreditCards: '/offer-management/financial-services/credit-cards',
  CustomOffers: '/offer-management/custom-offers',
  LifeInsurance: '/offer-management/financial-services/life-insurance',
  PersonalLoansBenchmarkReports:
    '/offer-management/financial-services/personal-loans/data-and-analytics/benchmark-reports',
  PersonalLoansCompliance:
    '/offer-management/financial-services/personal-loans/compliance',
  PersonalLoansDashboard:
    '/offer-management/financial-services/personal-loans/dashboard',
  PersonalLoansMCIConversionsReports:
    '/offer-management/financial-services/personal-loans/data-and-analytics/mci-reports/conversions',
  PersonalLoansMCIOffersReports:
    '/offer-management/financial-services/personal-loans/data-and-analytics/mci-reports/offers',
  PersonalLoansMCIRejectionsReports:
    '/offer-management/financial-services/personal-loans/data-and-analytics/mci-reports/rejections',
  Savings: '/offer-management/financial-services/savings',
  StudentLoanRefi: '/offer-management/financial-services/student-loan-refi',
};

const RootRoutes = {
  Accounts: '/accounts/[uuid]',
  DemandSubAccountDetail: '/demand-sub-accounts/[uuid]',
  DemandSubAccountDetailContractTerms:
    '/demand-sub-accounts/[uuid]/contract-terms',
  DemandSubAccountIndex: '/demand-sub-accounts',
  DemandSubAccounts: '/demand-sub-accounts',
  FeatureFlags: '/feature-flags',
};

const OfferCatalogRoutes = {
  Offers: '/offer-catalog/offers',
  OffersDetail: '/offers/[uuid]/[version]',
  ProductTypes: '/offer-catalog/product-types',
  ProductTypes_Details: '/offer-catalog/product-types/details',
};

const InternalRoutes = {
  ...RootRoutes,
  OfferCatalog: OfferCatalogRoutes,
};

module.exports = {
  DemandMVPOfferManagementRoute,
  InternalRoutes,
  Route,
};
